'use client';

import { useEffect } from 'react';

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

import { LIBRARY_SCRIPT } from './library-script';

gsap.registerPlugin(ScrollToPlugin);

/**
 * Runs the library's DOM script once its markup is on the page, handing it
 * GSAP for the strip's category-to-category glide. Guarded on the strip
 * already being filled, so React's development double-mount and a return
 * visit through client navigation each run it exactly once per fresh render
 * of the markup.
 */
export function LaunchLibraryScript() {
  useEffect(() => {
    const track = document.getElementById('strip-track');
    if (!track || track.childElementCount > 0) return;
    new Function('gsap', LIBRARY_SCRIPT)(gsap);
  }, []);
  return null;
}
